// extracted by mini-css-extract-plugin
export default {"button":"dGBKP","disabled":"Mk7c0","mobile-button":"rKia5","mobileButton":"rKia5"};